<template>
    <div v-if="showModal" class="alert-modal toggle-alert">
        <div class="alert-modal-container">
            <div class="modal-content">
                <div id="alert-modal" class="card bg-orange-gradLight">

                    <button class="btn-close" @click="closeModal">
                        <img :src="close" alt="close">
                    </button>

                    <div class="card-body">
                        <div class="mensages-container">
                            <img :src="warning" alt="warning" class="message-img">
                            <h1>Por favor, valida o teu promocode</h1>
                            <p>
                                Faz a validação do teu Promocode antes de finalizares a encomenda.
                            </p>

                            <div class="modal-bottom double">
                                <div class="text-center">
                                    <button class="btn-bg" @click="closeModal">Ok</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import icClose from '../../svg/ic_close_orange.svg'
import icWarning from '../../svg/ic_warning.svg'
import {isBoolean} from "../../../public/vendor/datatables-plugins/pdfmake/pdfmake";

export default {

    props: {
       showModal: false
    },
    emits: ['close-modal-promocode'],

    data() {
        return {
            close: icClose,
            warning: icWarning,
        }
    },

    watch: {
        showModal() {
            document.querySelector('html').classList.toggle('no-scroll');
            document.querySelector('body').classList.toggle('no-scroll');
        }
    },

    methods: {
        closeModal(){
            this.$emit('close-modal-promocode')
        }
    },
}
</script>

<style>

</style>
